import { renderAreaSeries } from './render-series-area';
import { renderLineSeries } from './render-series-line';
import { renderScatterSeries } from './render-series-scatter';

export function renderSeries(parentElem, graph, panel, series, xScale, yScale) {

	switch (series.config.type) {
		case 'line':
			renderLineSeries(parentElem, graph, panel, series, xScale, yScale);
			break;
		case 'area':
			renderAreaSeries(parentElem, graph, panel, series, xScale, yScale);
			break;
		case 'scatter':
			renderScatterSeries(parentElem, graph, panel, series, xScale, yScale);
			break;
	}

}



// WEBPACK FOOTER //
// ./utils/panelgraph/functions/render-series.js